import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import NavigationItem from '../NavigationItem/NavigationItem';
import * as actions from '../../../store/actions/index';

const NavigationItems = (props) => {
  const { getAllPostsList, getDomain, onMenu } = props;
  const [ showMenu, setShowMenu ] = useState(false);
  const [ width, setWidth ] = useState(window.innerWidth);
  const isMobile = width < 1024;

  useEffect(() => {
    getDomain();
    getAllPostsList();
    onMenu();

    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [getAllPostsList, getDomain, onMenu, isMobile]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  }

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }

  const menuClasses = [
    showMenu ? 'h-104':'h-0 lg:h-auto overflow-hidden',
    'w-full',
    'flex-grow',
    'lg:flex',
    'lg:items-center',
    'lg:w-auto',
    'transition-all',
    'ease-in-out',
    'duration-300',
  ]

  return (
    <>
      <div className="flex items-center flex-shrink-0 text-white mr-6 lg:hidden">
        <span className="font-semibold text-xl tracking-tight">Menú</span>
      </div>
      <div className="block lg:hidden">
        <button
          className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white"
          onClick={toggleMenu}>
          <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
        </button>
      </div>
      <div className={menuClasses.join(' ')}>
        <ul className="text-lg lg:text-xs xl:text-base lg:flex lg:justify-center lg:flex-grow">
          { props.menu.map((item, index) => (
            <NavigationItem key={`menu-${index}`} link={item.relative} click={isMobile ? toggleMenu : null}>{item.title}</NavigationItem>
          ))}
        </ul>
      </div>
    </>
  )
};

const mapsStateToProps = state => {
  return {
    menu: state.menu,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDomain: () => dispatch(actions.getDomain()),
    getAllPostsList: () => dispatch(actions.getAllPosts()),
    onMenu: () => dispatch(actions.getMenu())
  }
}

export default connect(mapsStateToProps, mapDispatchToProps)(NavigationItems);
